import React, { useState } from 'react';
import './SalesPage.css';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { AiFillHome } from 'react-icons/ai';
import { MdRestaurantMenu } from 'react-icons/md';
import { FaMoneyBillWave, FaUserFriends, FaGift } from 'react-icons/fa';
import { GiKnifeFork } from 'react-icons/gi';

const navItems = [
  'Home',
  'Product',
  'Sales',
  'Members',
  'Promotion',
  'Restaurant',
];

const navIcons = {
  Home: <AiFillHome className="nav-icon" />,
  Product: <MdRestaurantMenu className="nav-icon" />,
  Sales: <FaMoneyBillWave className="nav-icon" />,
  Members: <FaUserFriends className="nav-icon" />,
  Promotion: <FaGift className="nav-icon" />,
  Restaurant: <GiKnifeFork className="nav-icon" />,
};

// 销售数据
const salesData = {
  totalSales: 128500,
  totalTransactions: 3200,
  averageOrder: 40.16,
  topItems: [
    {
      rank: 1,
      name: 'Spicy Hot Pot',
      image: '/images/spicy-hot-pot.jpg',
      totalRevenue: 15600,
      totalOrders: 520
    },
    {
      rank: 2,
      name: 'Kung Pao Chicken',
      image: '/images/kung-pao-chicken.jpg',
      totalRevenue: 12300,
      totalOrders: 410
    },
    {
      rank: 3,
      name: 'Fish Fragrant Shredded Pork',
      image: '/images/fish-fragrant-pork.jpg',
      totalRevenue: 11700,
      totalOrders: 390
    }
  ],
  hourlySales: [
    { hour: '10:00', sales: 1200 },
    { hour: '11:00', sales: 1800 },
    { hour: '12:00', sales: 3200 },
    { hour: '13:00', sales: 2800 },
    { hour: '14:00', sales: 1500 },
    { hour: '15:00', sales: 1200 },
    { hour: '16:00', sales: 1400 },
    { hour: '17:00', sales: 2000 },
    { hour: '18:00', sales: 3500 },
    { hour: '19:00', sales: 4200 },
    { hour: '20:00', sales: 3800 },
    { hour: '21:00', sales: 2800 },
    { hour: '22:00', sales: 1800 }
  ]
};

// Overview表格数据
const overviewData = [
  {
    orderId: 'ORD001',
    date: '2024-06-15',
    time: '12:30',
    amount: 45.00,
    paymentMethod: 'visa',
    customer: 'John Smith',
    details: 'Spicy Hot Pot, Green Tea'
  },
  {
    orderId: 'ORD002',
    date: '2024-06-15',
    time: '13:15',
    amount: 32.00,
    paymentMethod: 'mastercard',
    customer: 'Sarah Johnson',
    details: 'Kung Pao Chicken, Steamed Rice'
  },
  {
    orderId: 'ORD003',
    date: '2024-06-15',
    time: '14:20',
    amount: 28.00,
    paymentMethod: 'cash',
    customer: 'Mike Chen',
    details: 'Fish Fragrant Shredded Pork'
  },
  {
    orderId: 'ORD004',
    date: '2024-06-15',
    time: '15:45',
    amount: 88.00,
    paymentMethod: 'paypal',
    customer: 'Lisa Wang',
    details: 'Peking Duck, Dim Sum Platter'
  },
  {
    orderId: 'ORD005',
    date: '2024-06-15',
    time: '16:30',
    amount: 35.00,
    paymentMethod: 'visa',
    customer: 'David Brown',
    details: 'Beef Noodle Soup, Orange Chicken'
  },
  {
    orderId: 'ORD006',
    date: '2024-06-15',
    time: '17:10',
    amount: 42.00,
    paymentMethod: 'mastercard',
    customer: 'Emma Davis',
    details: 'Sweet and Sour Fish, Steamed Rice'
  },
  {
    orderId: 'ORD007',
    date: '2024-06-15',
    time: '18:25',
    amount: 26.00,
    paymentMethod: 'cash',
    customer: 'Tom Wilson',
    details: 'Mapo Tofu, Green Tea'
  },
  {
    orderId: 'ORD008',
    date: '2024-06-15',
    time: '19:40',
    amount: 38.00,
    paymentMethod: 'visa',
    customer: 'Anna Lee',
    details: 'Dim Sum Platter, Hot and Sour Soup'
  },
  {
    orderId: 'ORD009',
    date: '2024-06-15',
    time: '20:15',
    amount: 30.00,
    paymentMethod: 'paypal',
    customer: 'Chris Taylor',
    details: 'Orange Chicken, Steamed Rice'
  },
  {
    orderId: 'ORD010',
    date: '2024-06-15',
    time: '21:00',
    amount: 55.00,
    paymentMethod: 'mastercard',
    customer: 'Rachel Green',
    details: 'Spicy Hot Pot, Kung Pao Chicken, Green Tea'
  }
];

// Sales Items表格数据
const salesItemsData = [
  {
    itemName: 'Spicy Hot Pot',
    quantitySold: 520,
    unitPrice: 30.00,
    totalRevenue: 15600,
    lastOrderDate: '2024-06-15',
    details: 'Premium hot pot with fresh ingredients'
  },
  {
    itemName: 'Kung Pao Chicken',
    quantitySold: 410,
    unitPrice: 28.00,
    totalRevenue: 11480,
    lastOrderDate: '2024-06-15',
    details: 'Classic Sichuan dish with peanuts'
  },
  {
    itemName: 'Fish Fragrant Shredded Pork',
    quantitySold: 390,
    unitPrice: 32.00,
    totalRevenue: 12480,
    lastOrderDate: '2024-06-15',
    details: 'Traditional Sichuan specialty'
  },
  {
    itemName: 'Beef Noodle Soup',
    quantitySold: 350,
    unitPrice: 35.00,
    totalRevenue: 12250,
    lastOrderDate: '2024-06-15',
    details: 'Rich beef broth with tender noodles'
  },
  {
    itemName: 'Sweet and Sour Fish',
    quantitySold: 280,
    unitPrice: 42.00,
    totalRevenue: 11760,
    lastOrderDate: '2024-06-15',
    details: 'Crispy fish with tangy sauce'
  },
  {
    itemName: 'Peking Duck',
    quantitySold: 120,
    unitPrice: 88.00,
    totalRevenue: 10560,
    lastOrderDate: '2024-06-15',
    details: 'Premium duck with pancakes'
  },
  {
    itemName: 'Mapo Tofu',
    quantitySold: 320,
    unitPrice: 26.00,
    totalRevenue: 8320,
    lastOrderDate: '2024-06-15',
    details: 'Spicy tofu with minced pork'
  },
  {
    itemName: 'Dim Sum Platter',
    quantitySold: 250,
    unitPrice: 38.00,
    totalRevenue: 9500,
    lastOrderDate: '2024-06-15',
    details: 'Assorted steamed dim sum'
  },
  {
    itemName: 'Orange Chicken',
    quantitySold: 380,
    unitPrice: 30.00,
    totalRevenue: 11400,
    lastOrderDate: '2024-06-15',
    details: 'Crispy chicken in orange sauce'
  },
  {
    itemName: 'Green Tea',
    quantitySold: 650,
    unitPrice: 8.00,
    totalRevenue: 5200,
    lastOrderDate: '2024-06-15',
    details: 'Premium green tea'
  }
];

// Reservations表格数据
const reservationsData = [
  {
    reservationId: 'RES001',
    date: '2024-06-15',
    time: '18:00',
    partySize: 4,
    customer: 'John Smith',
    phone: '+1-555-0123',
    status: 'confirmed',
    details: 'Window seat preferred'
  },
  {
    reservationId: 'RES002',
    date: '2024-06-15',
    time: '19:30',
    partySize: 2,
    customer: 'Sarah Johnson',
    phone: '+1-555-0124',
    status: 'confirmed',
    details: 'Anniversary celebration'
  },
  {
    reservationId: 'RES003',
    date: '2024-06-15',
    time: '20:00',
    partySize: 6,
    customer: 'Mike Chen',
    phone: '+1-555-0125',
    status: 'confirmed',
    details: 'Business dinner'
  },
  {
    reservationId: 'RES004',
    date: '2024-06-15',
    time: '17:30',
    partySize: 3,
    customer: 'Lisa Wang',
    phone: '+1-555-0126',
    status: 'cancelled',
    details: 'Cancelled due to illness'
  },
  {
    reservationId: 'RES005',
    date: '2024-06-15',
    time: '19:00',
    partySize: 5,
    customer: 'David Brown',
    phone: '+1-555-0127',
    status: 'confirmed',
    details: 'Birthday party'
  },
  {
    reservationId: 'RES006',
    date: '2024-06-15',
    time: '18:30',
    partySize: 2,
    customer: 'Emma Davis',
    phone: '+1-555-0128',
    status: 'confirmed',
    details: 'Date night'
  },
  {
    reservationId: 'RES007',
    date: '2024-06-15',
    time: '20:30',
    partySize: 4,
    customer: 'Tom Wilson',
    phone: '+1-555-0129',
    status: 'confirmed',
    details: 'Family dinner'
  },
  {
    reservationId: 'RES008',
    date: '2024-06-15',
    time: '17:00',
    partySize: 8,
    customer: 'Anna Lee',
    phone: '+1-555-0130',
    status: 'cancelled',
    details: 'Group cancelled'
  },
  {
    reservationId: 'RES009',
    date: '2024-06-15',
    time: '19:15',
    partySize: 3,
    customer: 'Chris Taylor',
    phone: '+1-555-0131',
    status: 'confirmed',
    details: 'Regular customer'
  },
  {
    reservationId: 'RES010',
    date: '2024-06-15',
    time: '18:45',
    partySize: 2,
    customer: 'Rachel Green',
    phone: '+1-555-0132',
    status: 'confirmed',
    details: 'First time visit'
  }
];

// Void Sales Items表格数据
const voidSalesData = [
  {
    orderId: 'ORD101',
    voidProductDetails: 'Spicy Hot Pot',
    voidDate: '2024-06-15',
    voidTime: '12:45',
    voidReason: 'Customer allergic to ingredients',
    details: 'Customer reported allergy to mushrooms'
  },
  {
    orderId: 'ORD102',
    voidProductDetails: 'Kung Pao Chicken',
    voidDate: '2024-06-15',
    voidTime: '13:20',
    voidReason: 'Wrong order preparation',
    details: 'Ordered mild, received spicy'
  },
  {
    orderId: 'ORD103',
    voidProductDetails: 'Beef Noodle Soup',
    voidDate: '2024-06-15',
    voidTime: '14:10',
    voidReason: 'Customer request',
    details: 'Customer changed mind'
  },
  {
    orderId: 'ORD104',
    voidProductDetails: 'Sweet and Sour Fish',
    voidDate: '2024-06-15',
    voidTime: '15:30',
    voidReason: 'Quality issue',
    details: 'Fish not fresh enough'
  },
  {
    orderId: 'ORD105',
    voidProductDetails: 'Mapo Tofu',
    voidDate: '2024-06-15',
    voidTime: '16:15',
    voidReason: 'Customer allergic to ingredients',
    details: 'Allergy to Sichuan peppercorns'
  },
  {
    orderId: 'ORD106',
    voidProductDetails: 'Dim Sum Platter',
    voidDate: '2024-06-15',
    voidTime: '17:45',
    voidReason: 'Wrong order preparation',
    details: 'Ordered steamed, received fried'
  },
  {
    orderId: 'ORD107',
    voidProductDetails: 'Orange Chicken',
    voidDate: '2024-06-15',
    voidTime: '18:20',
    voidReason: 'Customer request',
    details: 'Customer wanted different sauce'
  },
  {
    orderId: 'ORD108',
    voidProductDetails: 'Green Tea',
    voidDate: '2024-06-15',
    voidTime: '19:00',
    voidReason: 'Quality issue',
    details: 'Tea was too strong'
  },
  {
    orderId: 'ORD109',
    voidProductDetails: 'Peking Duck',
    voidDate: '2024-06-15',
    voidTime: '20:15',
    voidReason: 'Customer allergic to ingredients',
    details: 'Allergy to duck meat'
  },
  {
    orderId: 'ORD110',
    voidProductDetails: 'Fish Fragrant Shredded Pork',
    voidDate: '2024-06-15',
    voidTime: '21:30',
    voidReason: 'Wrong order preparation',
    details: 'Too spicy for customer'
  }
];

function SalesPage({ onNavigate }) {
  const [startDate, setStartDate] = useState('2024-06-01');
  const [endDate, setEndDate] = useState('2024-06-30');
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [activeTable, setActiveTable] = useState('overview');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const handleNavClick = (item) => {
    if (onNavigate) {
      onNavigate(item);
    }
  };

  const formatDateRange = () => {
    return `${startDate} - ${endDate}`;
  };

  // 获取当前表格数据
  const getCurrentTableData = () => {
    switch (activeTable) {
      case 'overview':
        return overviewData;
      case 'salesItems':
        return salesItemsData;
      case 'reservations':
        return reservationsData;
      case 'voidSales':
        return voidSalesData;
      default:
        return overviewData;
    }
  };

  const currentTableData = getCurrentTableData();
  const totalPages = Math.ceil(currentTableData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentData = currentTableData.slice(startIndex, endIndex);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const renderTable = () => {
    switch (activeTable) {
      case 'overview':
        return (
          <table className="sales-table">
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Date</th>
                <th>Time</th>
                <th>Amount</th>
                <th>Payment Method</th>
                <th>Customer</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              {currentData.map(item => (
                <tr key={item.orderId}>
                  <td>{item.orderId}</td>
                  <td>{item.date}</td>
                  <td>{item.time}</td>
                  <td>¥{item.amount.toFixed(2)}</td>
                  <td>
                    <span className={`payment-badge ${item.paymentMethod}`}>
                      {item.paymentMethod.charAt(0).toUpperCase() + item.paymentMethod.slice(1)}
                    </span>
                  </td>
                  <td>{item.customer}</td>
                  <td>{item.details}</td>
                </tr>
              ))}
            </tbody>
          </table>
        );
      case 'salesItems':
        return (
          <table className="sales-table">
            <thead>
              <tr>
                <th>Item Name</th>
                <th>Quantity Sold</th>
                <th>Unit Price</th>
                <th>Total Revenue</th>
                <th>Last Order Date</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              {currentData.map(item => (
                <tr key={item.itemName}>
                  <td>{item.itemName}</td>
                  <td>{item.quantitySold}</td>
                  <td>¥{item.unitPrice.toFixed(2)}</td>
                  <td>¥{item.totalRevenue.toFixed(2)}</td>
                  <td>{item.lastOrderDate}</td>
                  <td>{item.details}</td>
                </tr>
              ))}
            </tbody>
          </table>
        );
      case 'reservations':
        return (
          <table className="sales-table">
            <thead>
              <tr>
                <th>Reservation ID</th>
                <th>Date</th>
                <th>Time</th>
                <th>Party Size</th>
                <th>Customer</th>
                <th>Phone</th>
                <th>Status</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              {currentData.map(item => (
                <tr key={item.reservationId}>
                  <td>{item.reservationId}</td>
                  <td>{item.date}</td>
                  <td>{item.time}</td>
                  <td>{item.partySize}</td>
                  <td>{item.customer}</td>
                  <td>{item.phone}</td>
                  <td>
                    <span className={`status-badge ${item.status}`}>
                      {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
                    </span>
                  </td>
                  <td>{item.details}</td>
                </tr>
              ))}
            </tbody>
          </table>
        );
      case 'voidSales':
        return (
          <table className="sales-table">
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Void Product Details</th>
                <th>Void Date</th>
                <th>Void Time</th>
                <th>Void Reason</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              {currentData.map(item => (
                <tr key={item.orderId}>
                  <td>{item.orderId}</td>
                  <td>{item.voidProductDetails}</td>
                  <td>{item.voidDate}</td>
                  <td>{item.voidTime}</td>
                  <td>{item.voidReason}</td>
                  <td>{item.details}</td>
                </tr>
              ))}
            </tbody>
          </table>
        );
      default:
        return null;
    }
  };

  const getTableTitle = () => {
    switch (activeTable) {
      case 'overview':
        return 'Daily Sales Report';
      case 'salesItems':
        return 'Sales Items Report';
      case 'reservations':
        return 'Reservations Report';
      case 'voidSales':
        return 'Void Sales Items Report';
      default:
        return '';
    }
  };

  return (
    <div className="salespage-container">
      <nav className="sidebar">
        <div className="sidebar-title">Restaurant Management</div>
        <ul>
          {navItems.map(item => (
            <li 
              key={item} 
              className={item === 'Sales' ? 'active' : ''}
              onClick={() => handleNavClick(item)}
            >
              <span className="nav-icon">{navIcons[item]}</span> {item}
            </li>
          ))}
        </ul>
      </nav>
      
      <main className="sales-main">
        <div className="sales-header">
          <div className="date-picker-container">
            <button 
              className="date-picker-btn"
              onClick={() => setShowDatePicker(!showDatePicker)}
            >
              📅 Date Range: {formatDateRange()}
            </button>
            {showDatePicker && (
              <div className="date-picker-dropdown">
                <div className="date-input-group">
                  <label>Start Date:</label>
                  <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                </div>
                <div className="date-input-group">
                  <label>End Date:</label>
                  <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </div>
                <button 
                  className="apply-date-btn"
                  onClick={() => setShowDatePicker(false)}
                >
                  Apply
                </button>
              </div>
            )}
          </div>
        </div>

        <div className="sales-cards">
          <div className="sales-card">
            <div className="card-title">Total Sales</div>
            <div className="card-value">¥{salesData.totalSales.toLocaleString()}</div>
            <div className="card-desc">{formatDateRange()}</div>
          </div>
          <div className="sales-card">
            <div className="card-title">Total Transactions</div>
            <div className="card-value">{salesData.totalTransactions.toLocaleString()}</div>
            <div className="card-desc">{formatDateRange()}</div>
          </div>
          <div className="sales-card">
            <div className="card-title">Average Order</div>
            <div className="card-value">¥{salesData.averageOrder.toFixed(2)}</div>
            <div className="card-desc">{formatDateRange()}</div>
          </div>
        </div>

        <div className="sales-content">
          <div className="leaderboard-section">
            <h2>Top Selling Items</h2>
            <div className="leaderboard">
              {salesData.topItems.map(item => (
                <div key={item.rank} className="leaderboard-item">
                  <div className="rank-badge">{item.rank}</div>
                  <img 
                    src={item.image} 
                    alt={item.name}
                    className="item-image"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'inline';
                    }}
                  />
                  <span className="item-fallback" style={{display: 'none'}}>🍽️</span>
                  <div className="item-info">
                    <div className="item-name">{item.name}</div>
                    <div className="item-revenue">¥{item.totalRevenue.toLocaleString()}</div>
                    <div className="item-orders">{item.totalOrders} orders</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="chart-section">
            <h2>Hourly Sales</h2>
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={salesData.hourlySales}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="hour" />
                <YAxis />
                <Tooltip />
                <Bar dataKey="sales" fill="#232946" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div className="table-section">
          <div className="table-header">
            <h2>{getTableTitle()}</h2>
            <div className="table-tabs">
              <button 
                className={`tab-btn ${activeTable === 'overview' ? 'active' : ''}`}
                onClick={() => {
                  setActiveTable('overview');
                  setCurrentPage(1);
                }}
              >
                Overview
              </button>
              <button 
                className={`tab-btn ${activeTable === 'salesItems' ? 'active' : ''}`}
                onClick={() => {
                  setActiveTable('salesItems');
                  setCurrentPage(1);
                }}
              >
                Sales Items
              </button>
              <button 
                className={`tab-btn ${activeTable === 'reservations' ? 'active' : ''}`}
                onClick={() => {
                  setActiveTable('reservations');
                  setCurrentPage(1);
                }}
              >
                Reservations
              </button>
              <button 
                className={`tab-btn ${activeTable === 'voidSales' ? 'active' : ''}`}
                onClick={() => {
                  setActiveTable('voidSales');
                  setCurrentPage(1);
                }}
              >
                Void Sales Items
              </button>
            </div>
          </div>

          <div className="table-container">
            {renderTable()}
          </div>

          <div className="pagination">
            <button 
              className="pagination-btn"
              disabled={currentPage === 1}
              onClick={() => handlePageChange(currentPage - 1)}
            >
              Previous
            </button>
            <span className="page-info">
              Page {currentPage} of {totalPages}
            </span>
            <button 
              className="pagination-btn"
              disabled={currentPage === totalPages}
              onClick={() => handlePageChange(currentPage + 1)}
            >
              Next
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}

export default SalesPage; 